import { FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { ChannelRecordingTaskAggregations } from '@/features/recorder/types';

type TableHeaderByStatusProps = {
  aggregation?: ChannelRecordingTaskAggregations;
};
export function TableHeaderByStatus({ aggregation }: TableHeaderByStatusProps) {
  const { t } = useTranslation();
  const total = Object.values(aggregation ?? {}).reduce((value, sum) => value + sum, 0);

  return (
    <div className="mb-2 flex flex-col justify-end gap-2 sm:flex-row">
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm"></span>
        <Typography fontSize={FontSizeEnum.Xs}>{t('Total')}:</Typography>
        <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
          {total}
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm bg-accent-static-medium-light"></span>
        <Typography fontSize={FontSizeEnum.Xs}>
          {t('Programada')}:
          <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
            {aggregation?.starting ?? 0}
          </Typography>
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm bg-extra-new-35"></span>
        <Typography fontSize={FontSizeEnum.Xs}>
          {t('No programada')}:{' '}
          <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
            {aggregation?.timeout ?? 0}
          </Typography>
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm bg-feedback-info-10"></span>
        <Typography fontSize={FontSizeEnum.Xs}>
          {t('Grabando')}:{' '}
          <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
            {aggregation?.running ?? 0}
          </Typography>
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm bg-feedback-success-10"></span>
        <Typography fontSize={FontSizeEnum.Xs}>
          {t('Terminada')}:{' '}
          <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
            {aggregation?.completed ?? 0}
          </Typography>
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm bg-extra-new-85"></span>
        <Typography fontSize={FontSizeEnum.Xs}>
          {t('Pausada')}:{' '}
          <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
            {aggregation?.paused ?? 0}
          </Typography>
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <span className="h-4 w-4 rounded-sm bg-feedback-warning-10"></span>
        <Typography fontSize={FontSizeEnum.Xs}>{t('Cancelada')}:</Typography>
        <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
          {aggregation?.cancelled ?? 0}
        </Typography>
        <div className="flex items-center gap-1">
          <span className="h-4 w-4 rounded-sm bg-feedback-error-10"></span>
          <Typography fontSize={FontSizeEnum.Xs}>{t('Error')}:</Typography>
          <Typography fontSize={FontSizeEnum.Xs} weight={FontWeightEnum.Semibold}>
            {aggregation?.error ?? 0}
          </Typography>
        </div>
      </div>
    </div>
  );
}
